{
  "computed": {},
  "localState": {},
  "props": {},
  "schemaVersion": "4.0",
  "blockType": "hero-minimal"
}
